import { Loader as MantineLoader, LoaderProps as MantineLoaderProps } from "@mantine/core";

export interface LoaderProps extends MantineLoaderProps {
  padding?: string;
}

const Loader = ({ padding, ...props }: LoaderProps) => {
  return (
    <div
      style={{
        display: "flex",
        placeContent: "center",
        padding: padding || "10px",
      }}
    >
      <MantineLoader {...props} color={"var(--color-background-transparent-secondary)"} />
    </div>
  );
};

export default Loader;
